import * as React from "react";
const ProcessEngineeringSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={68}
    height={68}
    fill="none"
    {...props}
  >
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.03}
      rx={30}
    />
    <rect
      width={60}
      height={60}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.06}
      strokeWidth={8}
      rx={30}
    />
    <g clipPath="url(#a)">
      <path
        fill="#EF4136"
        d="M36.001 37.71a8.5 8.5 0 1 0-8.987 0c-2.581.844-4.904 2.423-6.771 4.645a1 1 0 0 0 1.53 1.288c2.51-2.995 5.967-4.644 9.728-4.644 3.762 0 7.219 1.649 9.734 4.644a1 1 0 1 0 1.531-1.288c-1.867-2.222-4.19-3.8-6.765-4.646Zm-11-7.21a6.5 6.5 0 1 1 6.5 6.5 6.507 6.507 0 0 1-6.5-6.5Zm24.708 4.207-4 4a.998.998 0 0 1-1.415 0l-2-2a1 1 0 0 1 1.415-1.415L45 36.585l3.293-3.293a1 1 0 0 1 1.415 1.415Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M18 18h32v32H18z" />
      </clipPath>
    </defs>
  </svg>
);
export default ProcessEngineeringSVG;
